import React from 'react';
import PropTypes from 'prop-types';
import {DatePicker} from 'core/components';
import {QueryUtility} from 'core/utils';
import {defaultTemplate} from 'core/hoc';
import moment from 'moment';
import { action } from 'mobx';
import { QueryPickerStore } from 'core/stores';
import { toDateObject } from 'core/utils';

class DateQueryPickerTemplate extends React.Component {
    constructor(props){
        super();

        this.queryUtility = props.queryUtility;
        this.store = props.store;
        this.propertyName = props.propertyName;

        let val = toDateObject(this.queryUtility.filter[this.propertyName]);
        this.store.setValue(val)
    }

    @action.bound
    onValueChange(value) {
        const date = value ? moment(value) : null;

        if (!value) {
            this.store.setValue(null);
            delete this.queryUtility.filter[this.propertyName];
            return;
        }

        if (!date.isValid()) {
            return;
        }

        this.store.setValue(value);
        this.queryUtility.filter[this.propertyName] = date.format('YYYY-MM-DD');
    }
  
    render ()  {
        return (
            <DatePicker
                value={this.store.value}
                onChange={this.onValueChange}
            />
        )
    }
}

DateQueryPickerTemplate.propTypes = {
    queryUtility: PropTypes.instanceOf(QueryUtility),
    store: PropTypes.instanceOf(QueryPickerStore),
    propertyName: PropTypes.string,
    onChange: PropTypes.func,
    timeZone: PropTypes.string
};

DateQueryPickerTemplate.defaultProps = {
    onChange: () => {
    }
};

export default defaultTemplate(DateQueryPickerTemplate);
